import { render, staticRenderFns } from "./Password_find.vue?vue&type=template&id=0a741ce2&scoped=true&"
import script from "./Password_find.vue?vue&type=script&lang=js&"
export * from "./Password_find.vue?vue&type=script&lang=js&"
import style0 from "./Password_find.vue?vue&type=style&index=0&id=0a741ce2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a741ce2",
  null
  
)

export default component.exports